import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { COMPANY, LOGOS } from "@/lib/constants";
import { BBBSeal } from "./BBBSeal";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#gallery" },
  { label: "Videos", href: "#videos" },
  { label: "Blog", href: "/blog" },
  { label: "Reviews", href: "#google-reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Quote", href: "/quote" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0B1726]/85 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-24 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src={LOGOS.elephant}
            alt="All Day Power Washing elephant logo"
            className="h-16 w-16 sm:h-20 sm:w-20 object-contain drop-shadow-[0_2px_8px_rgba(230,180,69,0.25)]"
          />
          <div className="font-heading font-black text-lg sm:text-xl uppercase tracking-tight text-white leading-none">
            All Day <span className="text-[#E6B445]">Power Washing</span>
          </div>
        </a>

        <div className="hidden sm:flex items-center ml-3 shrink-0" data-testid="header-bbb-seal">
          <BBBSeal className="[&_img]:h-16 sm:[&_img]:h-20 [&_img]:w-auto [&_img]:max-w-none" />
        </div>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace("/", "-")}`}
              className="font-heading uppercase text-sm tracking-[0.2em] text-slate-300 hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={COMPANY.phoneHref}
            data-testid="header-phone-link"
            className="hidden sm:flex items-center gap-2 font-heading uppercase text-sm tracking-wider text-white hover:text-[#E6B445] transition-colors"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>
          <a
            href="/quote"
            data-testid="header-get-quote-btn"
            className="hidden md:inline-flex bg-[#1E88E5] hover:bg-[#42A5F5] text-white font-heading font-bold tracking-wider uppercase px-5 py-3 rounded-sm text-sm transition-all"
          >
            Get Quote
          </a>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Open menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0B1726] border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              onClick={() => setOpen(false)}
              className="font-heading uppercase text-base tracking-wider text-slate-200 hover:text-white"
            >
              {n.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            className="flex items-center gap-2 font-heading uppercase text-base tracking-wider text-[#E6B445]"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phone}
          </a>
        </div>
      )}
    </header>
  );
};
